import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function ProduktEditaceWidgetTitleDescription({ produkt, loading }) {
  const message = useServerMessage();
  const { titleNew } = useMessages();

  return loading ? (
    <PlaceholderText>Elektricka trakce</PlaceholderText>
  ) : produkt ? (
    <>{`${message(produkt, "nazev")}`}</>
  ) : (
    titleNew()
  );
}

ProduktEditaceWidgetTitleDescription.propTypes = {
  loading: T.bool,
  produkt: T.object
};

export default React.memo(ProduktEditaceWidgetTitleDescription);
